export const uischema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/licenseNumber',
        },
        {
          type: 'Control',
          scope: '#/properties/dateOfService',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/therapistFirstName',
        },
        {
          type: 'Control',
          scope: '#/properties/therapistLastName',
        },
      ],
    },
    {
      type: 'Control',
      scope: '#/properties/notes',
      options: {
        multi: true,
      },
    },
  ],
};
